/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScenarioType } from './InternalApiScenarioType';
import {
    InternalApiScenarioTypeFromJSON,
    InternalApiScenarioTypeFromJSONTyped,
    InternalApiScenarioTypeToJSON,
    InternalApiScenarioTypeToJSONTyped,
} from './InternalApiScenarioType';

/**
 * 
 * @export
 * @interface InternalApiScoreResult
 */
export interface InternalApiScoreResult {
    /**
     * 
     * @type {string}
     * @memberof InternalApiScoreResult
     */
    reason: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScoreResult
     */
    details: string;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScoreResult
     */
    score: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScoreResult
     */
    weight: number;
    /**
     * 
     * @type {InternalApiScenarioType}
     * @memberof InternalApiScoreResult
     */
    scenarioType?: InternalApiScenarioType;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScoreResult
     */
    alertId?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof InternalApiScoreResult
     */
    relatedTransactions?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiScoreResult
     */
    includeRelatedTransactions?: boolean;
}



/**
 * Check if a given object implements the InternalApiScoreResult interface.
 */
export function instanceOfInternalApiScoreResult(value: object): value is InternalApiScoreResult {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    if (!('weight' in value) || value['weight'] === undefined) return false;
    return true;
}

export function InternalApiScoreResultFromJSON(json: any): InternalApiScoreResult {
    return InternalApiScoreResultFromJSONTyped(json, false);
}

export function InternalApiScoreResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScoreResult {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
        'details': json['details'],
        'score': json['score'],
        'weight': json['weight'],
        'scenarioType': json['scenarioType'] == null ? undefined : InternalApiScenarioTypeFromJSON(json['scenarioType']),
        'alertId': json['alertId'] == null ? undefined : json['alertId'],
        'relatedTransactions': json['relatedTransactions'] == null ? undefined : json['relatedTransactions'],
        'includeRelatedTransactions': json['includeRelatedTransactions'] == null ? undefined : json['includeRelatedTransactions'],
    };
}

export function InternalApiScoreResultToJSON(json: any): InternalApiScoreResult {
    return InternalApiScoreResultToJSONTyped(json, false);
}

export function InternalApiScoreResultToJSONTyped(value?: InternalApiScoreResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
        'details': value['details'],
        'score': value['score'],
        'weight': value['weight'],
        'scenarioType': InternalApiScenarioTypeToJSON(value['scenarioType']),
        'alertId': value['alertId'],
        'relatedTransactions': value['relatedTransactions'],
        'includeRelatedTransactions': value['includeRelatedTransactions'],
    };
}

